import {FC} from 'react'
import {UserExtended} from '@/features/users/types.ts'
import {StyledStatusBullet} from '@/features/users/components/status-bullet/style.ts'

export const StatusBullet: FC<{status: UserExtended['status1']}> = ({status}) => <StyledStatusBullet $status={status} />
